/**
 * @generated SignedSource<<8c3b03b8fb6396b80fcbe76c8d0dfbc0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "Contract",
    "kind": "LinkedField",
    "name": "acceptWithMyself",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "client",
        "plural": false,
        "selections": (v2/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientEmail",
        "storageKey": null
      },
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "merchant",
        "plural": false,
        "selections": (v2/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "note",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "role",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "shareAccessPagesAcceptWithMyselfMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "shareAccessPagesAcceptWithMyselfMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "6f55e511c3c2bb23d119de3ef3fe95a9",
    "id": null,
    "metadata": {},
    "name": "shareAccessPagesAcceptWithMyselfMutation",
    "operationKind": "mutation",
    "text": "mutation shareAccessPagesAcceptWithMyselfMutation(\n  $request: AcceptWithMyselfRequestInput\n) {\n  acceptWithMyself(request: $request) {\n    client {\n      id\n    }\n    clientEmail\n    id\n    merchant {\n      id\n    }\n    note\n    role\n    status\n    version\n  }\n}\n"
  }
};
})();

node.hash = "a473ecd781de7e6b9826d1bb679f3a0a";

module.exports = node;
